// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"1e84a944","927":"bb6e7c9f"}[chunkId] + ".chunk.css";
};